import { render, staticRenderFns } from "./CtaBar.vue?vue&type=template&id=2cb644b4"
import script from "./CtaBar.vue?vue&type=script&lang=js"
export * from "./CtaBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports